import { IAttachment } from "../../caseLawDocuments/model/Attachment";
import AttachmentMapper from "../../caseLawDocuments/service/AttachmentMapper";
import AttachmentParamMapper from "../../caseLawDocuments/service/AttachmentParamMapper";
import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";

export default class GetAttachmentsForLegalViewsInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachment>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(legalViewId: number) {
    return this.resource.execute(
      `legal-views/${legalViewId}/attachments`,
      AttachmentMapper,
      AttachmentParamMapper
    );
  }
}
